export const ucFirst = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
